import { useMobileNativeShare, useShareCtaPlacement } from '#src/app/pages/petitionDetails/shared/hooks';
import type { ShareAction } from '#src/app/shared/hooks/share';

type UsePetitionHeadingMobileReturn = ModelHookResult<{
	shareAction: ShareAction<'mobileNativeShare'> | null;
	suppressed: boolean;
}>;

/**
 * `suppressed` is derived from the same `useShareCtaPlacement()` the sign-CTA affordance uses
 * (CHANGE-98647) — a second, independently-derived gate is how the original two-entry-point bug
 * happened. Per KTD3, this does not additionally gate on the video-first hero layout.
 */
export function usePetitionHeadingMobile(): UsePetitionHeadingMobileReturn {
	const shareAction = useMobileNativeShare('petition_show_image');
	const placement = useShareCtaPlacement();

	return {
		data: {
			shareAction,
			suppressed: !!placement,
		},
	};
}
